import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// dashboard, 用户列表（头像、昵称、手机号、会员等级、积分、查看订单、查看积分记录），会员列表，签到图片库，分类管理，商品管理，订单列表
const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/dashboard/index.vue'),
    meta: { title: '总览' }
  },
  {
    path: '/users',
    name: 'User',
    component: () => import('../views/user/index.vue'),
    meta: { title: '用户' }
  },
  {
    path: '/users/:id',
    name: 'UserDetail',
    component: () => import('../views/user/detail.vue'),
    meta: { title: '用户详情', activeMenuPath: '/users' }
  },
  {
    path: '/members',
    name: 'Member',
    component: () => import('../views/user/index.vue'), // 和 /users 同一个组件
    meta: { title: '会员' },
    beforeEnter: (to, from, next) => {
      // 给 query 设置默认值
      if (!to.query.mode) {
        next({ ...to, query: { ...to.query, mode: 'vip' } })
      } else {
        next()
      }
    }
  },
  {
    path: '/check-in-images',
    name: 'CheckInImages',
    component: () => import('../views/check-in/image.vue'),
    meta: { title: '签到图库', activeMenuPath: '/check-in-records' }
  },
  {
    path: '/check-in-records',
    name: 'CheckInRecords',
    component: () => import('../views/check-in/index.vue'),
    meta: { title: '签到记录' }
  },
  {
    path: '/categories',
    name: 'Category',
    component: () => import('../views/shop/category.vue'),
    meta: { title: '分类' }
  },
  {
    path: '/spus',
    name: 'Spu',
    component: () => import('../views/shop/spu.vue'),
    meta: { title: '商品' }
  },
  {
    path: '/spu/form',
    name: 'SpuForm',
    component: () => import('../views/shop/spu-form.vue'),
    meta: { title: '商品', activeMenuPath: '/spus' }
  },
  {
    path: '/orders',
    name: 'Order',
    component: () => import('../views/shop/order.vue'),
    meta: { title: '订单', activeMenuPath: '/delivery-notes' }
  },
  {
    path: '/delivery-notes',
    name: 'DeliveryNote',
    component: () => import('../views/shop/delivery-note.vue'),
    meta: { title: '发货单' }
  },
  {
    path: '/prize-quizzes',
    name: 'PrizeQuizzes',
    component: () => import('../views/reward-points/prize-quiz.vue'),
    meta: { title: '每日一题' }
  },
  {
    path: '/prize-quizzes/form',
    name: 'PrizeQuizForm',
    component: () => import('../views/reward-points/prize-quiz-form.vue'),
    meta: { title: '题目', activeMenuPath: '/prize-quizzes' }
  },
  {
    path: '/prize-quiz-records',
    name: 'PrizeQuizRecords',
    component: () => import('../views/reward-points/prize-quiz-record.vue'),
    meta: { title: '答题记录' }
  },
  {
    path: '/reward-points-accounts',
    name: 'RewardPointsAccounts',
    component: () => import('../views/reward-points/account.vue'),
    meta: { title: '积分账户' }
  },
  {
    path: '/reward-points-accounts/:id',
    name: 'RewardPointsAccountDetail',
    component: () => import('../views/reward-points/account-detail.vue'),
    meta: { title: '积分账户详情', activeMenuPath: '/reward-points-accounts' }
  },
  {
    path: '/posts',
    name: 'PostList',
    component: () => import('../views/content/post.vue'),
    meta: { title: '帖子' }
  },
  {
    path: '/sliders',
    name: 'SliderList',
    component: () => import('../views/content/slider.vue'),
    meta: { title: '轮播图' }
  },
  {
    path: '/sliders/form',
    name: 'SliderForm',
    component: () => import('../views/content/slider-form.vue'),
    meta: { title: '轮播图', activeMenuPath: '/sliders' }
  },
  {
    path: '/notices',
    name: 'NoticeList',
    component: () => import('../views/content/notice.vue'),
    meta: { title: '通知' }
  },
  {
    path: '/notices/form',
    name: 'NoticeForm',
    component: () => import('../views/content/notice-form.vue'),
    meta: { title: '通知', activeMenuPath: '/notices' }
  },
  {
    path: '/settings',
    name: 'AssetSetting',
    component: () => import('../views/asset/setting.vue'),
    meta: { title: '系统设置' }
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
    meta: { title: '登录' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => err)
}

export default router
